import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import teamReducer from './slices/teamSlice';
import matchesReducer from './slices/matchesSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    team: teamReducer,
    matches: matchesReducer,
  },
});

export default store;
